import { ConfigProvider, Table, TableProps } from "antd"

import variables from "@/_styles/variables.module.scss"

export const CustomTable = (props: TableProps) => {
    return (
        <>
            <ConfigProvider 
                theme={{ 
                    hashed: false,
                    components: {
                        Table: {
                            headerBg: "transparent",
                            headerColor: variables.tableSubTitleColor,
                            borderColor: variables.tableBorderColor,
                            rowHoverBg: variables.tableHoverColor
                        }
                      }
                }}
            >
                <Table {...props} scroll={{ x: true }}>
                    {props.children}
                </Table>
            </ConfigProvider>
        </>
    )
}